import React from "react";

function Header() {
  return (
    <header>
      <h1>Word Game</h1>
      <p>by Scott Scharl</p>
    </header>
  );
}

export default Header;
